import { render, staticRenderFns } from "./PanelistScore.vue?vue&type=template&id=127af4d6"
import script from "./PanelistScore.vue?vue&type=script&lang=js"
export * from "./PanelistScore.vue?vue&type=script&lang=js"
import style0 from "./PanelistScore.vue?vue&type=style&index=0&id=127af4d6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports